import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import endImage from '../../assets/end-image.svg'

import Button from '../../components/Button'
import Header from '../../components/Header'

import { Container, Content, HandleNew, Line } from './styles'

const End: React.FC = () => {
  const history = useHistory()

  useEffect(() => {
    localStorage.removeItem('@Serpros:cpfFuncionario')
    localStorage.removeItem('@Serpros:erroProps')
    localStorage.removeItem('@Serpros:financialIndicationData')
    localStorage.removeItem('@Serpros:goalsSelected')
    localStorage.removeItem('@Serpros:legalIndicationData')
    localStorage.removeItem('@Serpros:menorIdade')
    localStorage.removeItem('@Serpros:participantsGroup')
    localStorage.removeItem('@Serpros:PercentualValuePercent')
    localStorage.removeItem('@Serpros:receiveTypeSelected')
    localStorage.removeItem('@Serpros:respFinanceiro')
    localStorage.removeItem('@Serpros:respLegal')
    localStorage.removeItem('@Serpros:respLegalEqualFin')
    localStorage.removeItem('@Serpros:TimeValueYears')
    localStorage.removeItem('@Serpros:totalRentability')
    localStorage.removeItem('@Serpros:userAccount')
    localStorage.removeItem('@Serpros:userAddress')
    localStorage.removeItem('@Serpros:userData')
    localStorage.removeItem('@Serpros:userDetails')
    localStorage.removeItem('@Serpros:indicationData')
    localStorage.removeItem('@Serpros:Indicado')
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <strong>
            Pronto! Seu pedido de adesão ao Plano Serpros Ser+ foi salvo com
            sucesso!
          </strong>
          <img src={endImage} alt="Finalizar" />

          <p>
            Agora nossos especialistas irão conferir todos os detalhes para a
            conclusão da sua adesão.
          </p>

          <div>
            <strong>ACESSE O NOSSO SITE:</strong>
            <a
              href="https://serpros.com.br/plano_ser-mais/"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.serpros.com.br
            </a>
          </div>

          <Line />

          <HandleNew>
            <h4>Que tal realizar a adesão de mais algum familiar?</h4>
            <Button
              type="button"
              color="blue"
              width="large"
              onClick={() => history.push('/')}
            >
              Sim, eu quero!
            </Button>
          </HandleNew>
        </Content>
      </Container>
    </>
  )
}

export default End
